export const pmaxCampaignsQueryKey = ["pmax-campaigns"];
